<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('admin.interfaces.pageMeldeclient.title') }}
    </portal>
    <template v-if="config !== null">
      <card :title="$t('admin.interfaces.pageMeldeclient.card.general')" :rows="isAVS ? '2' : '1'" cols="12 6@desktop">
        <hm-card-inner v-if="isFeratel && isEmpty(config.nummernkreise)" full-size>
          <hm-col cols="12">
            <span class="error-text error-text--full-size error-text--no-margin col-12">{{ $t('admin.interfaces.pageMeldeclient.warningFeratelNoMeldeblattNumbers') }}</span>
          </hm-col>
        </hm-card-inner>
        <hm-card-inner :title="$t('admin.interfaces.pageMeldeclient.card.typeName')">
          <hm-input-toggle :label="$t('admin.interfaces.pageMeldeclient.enabled')"
                           :enabled-title="$t('enabled')"
                           :disabled-title="$t('disabled')"
                           v-model="config.enabled"
                           cols="12 6@hd start-1"
                           name="enabled" />
          <hm-input-select id="typ"
                           :disabled="!hasRole('ROLE_SYSADMIN')"
                           v-model="config.typ"
                           :label="$t('admin.interfaces.pageMeldeclient.typ')"
                           name="typ"
                           enum-name="MeldeclientTyp"
                           cols="12 6@hd start-1" />
          <hm-input-select v-if="config.typ === 'Deskline3VTPMS'"
                           id="typ"
                           :disabled="!hasRole('ROLE_SYSADMIN')"
                           v-model="config.alternateTarget"
                           :label="$t('admin.interfaces.pageMeldeclient.alternateTarget')"
                           name="typ"
                           enum-name="MedeclientAlternateTarget"
                           cols="12 6@hd start-1" />
          <hm-input id="name"
                    :label="$t('admin.interfaces.pageMeldeclient.name')"
                    v-model="config.name"
                    cols="12 6@hd start-1"
                    name="name" />
          <hm-input-number id="maxNumberGuests"
                           :label="$t('admin.interfaces.pageMeldeclient.maxNumberGuests')"
                           v-model="config.maxNumberGuests"
                           cols="12 6@hd start-1"
                           name="maxNumberGuests" />
          <hm-input-number id="maxNumberGuestsGroup"
                           :label="$t('admin.interfaces.pageMeldeclient.maxNumberGuestsGroup')"
                           v-model="config.maxNumberGuestsGroup"
                           cols="12 6@hd start-1"
                           name="maxNumberGuestsGroup" />
          <hm-textarea id="meldeblattAddress"
                       :label="$t('admin.interfaces.pageMeldeclient.meldeblattAddress')"
                       v-model="config.meldeblattAddress"
                       cols="12 6@hd start-1"
                       name="meldeblattAddress" />
          <hm-textarea id="meldeblattExtension"
                       :label="$t('admin.interfaces.pageMeldeclient.meldeblattExtension')"
                       :disabled="!hasRole('ROLE_SYSADMIN')"
                       v-model="config.meldeblattExtension"
                       cols="12 6@hd start-1"
                       name="meldeblattExtension" />
          <hm-input v-if="!isAVS"
                    id="currentMeldeblattNumber"
                    :label="$t('admin.interfaces.pageMeldeclient.currentMeldeblattNumber')"
                    :disabled="true"
                    v-model="config.currentMeldeblattNumber"
                    cols="12 6@hd start-1"
                    name="currentMeldeblattNumber" />
        </hm-card-inner>
        <hm-card-inner v-if="!isEmpty(config.gastarten)" :full-size="true" :title="$t('admin.interfaces.pageMeldeclient.card.gastarten')">
          <hm-table :hover="false"
                    :columns="isAVS ? '4' : '5'"
                    :grid-template-columns="`1fr 5fr 1fr 1fr ${isAVS ? '1fr' : ''}`"
                    min-width="400px">
            <template slot="table-head">
              <div class="hm-table__th">{{ $t('admin.interfaces.pageMeldeclient.gastarten.code') }}</div>
              <div class="hm-table__th">{{ $t('admin.interfaces.pageMeldeclient.gastarten.name') }}</div>
              <div class="hm-table__th">{{ $t('admin.interfaces.pageMeldeclient.gastarten.ageFrom') }}</div>
              <div class="hm-table__th">{{ $t('admin.interfaces.pageMeldeclient.gastarten.ageUntil') }}</div>
              <div v-if="isAVS" class="hm-table__th">Begleitperson?</div>
            </template>
            <template v-for="(gastart, gastartIdx) in config.gastarten">
              <template v-if="isFeratel">
                <div class="hm-table__td" v-html="gastart.code"></div>
                <div class="hm-table__td" v-html="gastart.name.de"></div>
                <div class="hm-table__td" v-html="gastart.ageFrom"></div>
                <div class="hm-table__td" v-html="gastart.ageUntil"></div>
              </template>
              <template v-else-if="isAVS">
                <div class="hm-table__td" v-html="gastart.code"></div>
                <div class="hm-table__td" v-html="gastart.name.de"></div>
                <div class="hm-table__td">
                  <hm-input-number :label="$t('admin.interfaces.pageMeldeclient.gastarten.ageFrom')"
                                   :inline="true"
                                   v-model="gastart.ageFrom"
                                   :id="`ageFrom-${gastartIdx}`"
                                   name="ageFrom" />
                </div>
                <div class="hm-table__td">
                  <hm-input-number :label="$t('admin.interfaces.pageMeldeclient.gastarten.ageUntil')"
                                   :inline="true"
                                   v-model="gastart.ageUntil"
                                   :id="`ageUntil-${gastartIdx}`"
                                   name="ageUntil" />
                </div>
                <div class="hm-table__td">
                  <hm-input-checkbox :inline="true"
                                     :value="!gastart.primaryGuestOnly"
                                     :id="`primaryGuestOnly-${gastartIdx}`"
                                     label="Begleitperson?"
                                     name="primaryGuestOnly"
                                     @input="(value) => { gastart.primaryGuestOnly = !value; }" />
                </div>
              </template>
              <template v-else>
                <div class="hm-table__td">
                  <hm-input :label="$t('admin.interfaces.pageMeldeclient.gastarten.code')"
                            :inline="true"
                            :id="`code-${gastartIdx}`"
                            v-model="gastart.code"
                            name="code" />
                </div>
                <div class="hm-table__td">
                  <hm-input :label="$t('admin.interfaces.pageMeldeclient.gastarten.name')"
                            :inline="true"
                            v-model="gastart.name.de"
                            :id="`name-${gastartIdx}`"
                            name="name" />
                </div>
                <div class="hm-table__td">
                  <hm-input-number :label="$t('admin.interfaces.pageMeldeclient.gastarten.ageFrom')"
                                   :inline="true"
                                   v-model="gastart.ageFrom"
                                   :id="`ageFrom-${gastartIdx}`"
                                   name="ageFrom" />
                </div>
                <div class="hm-table__td">
                  <hm-input-number :label="$t('admin.interfaces.pageMeldeclient.gastarten.ageUntil')"
                                   :inline="true"
                                   v-model="gastart.ageUntil"
                                   :id="`ageUntil-${gastartIdx}`"
                                   name="ageUntil" />
                </div>
              </template>
            </template>
          </hm-table>
        </hm-card-inner>
        <hm-card-inner v-if="!isEmpty(config.nummernkreise) && !isAVS"
                       :full-size="true"
                       :title-clickable="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                       :title="$t('admin.interfaces.pageMeldeclient.card.nummernkreise')"
                       @clickTitle="nummernkreiseLocked = !nummernkreiseLocked">
          <hm-table :hover="false"
                    min-width="400px"
                    columns="2"
                    grid-template-columns="1fr 1fr">
            <template slot="table-head">
              <div class="hm-table__th">{{ $t('admin.interfaces.pageMeldeclient.nummernkreise.von') }}</div>
              <div class="hm-table__th">{{ $t('admin.interfaces.pageMeldeclient.nummernkreise.bis') }}</div>
            </template>
            <template v-for="(nummernkreis, nummernkreisIdx) in config.nummernkreise">
              <template v-if="nummernkreiseLocked && savedConfig.nummernkreise.some(it => it.minimumInteger === nummernkreis.minimumInteger && it.maximumInteger === nummernkreis.maximumInteger)">
                <div class="hm-table__td" v-html="nummernkreis.minimumInteger"></div>
                <div class="hm-table__td" v-html="nummernkreis.maximumInteger"></div>
              </template>
              <template v-else-if="(config.typ !== 'Deskline3VTPMS' && hasRole('ROLE_SYSADMIN')) || hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')">
                <div class="hm-table__td">
                  <hm-input-number :label="$t('admin.interfaces.pageMeldeclient.nummernkreise.von')"
                                   :inline="true"
                                   :id="`minimumInteger-${nummernkreisIdx}`"
                                   v-model="nummernkreis.minimumInteger"
                                   name="minimumInteger" />
                </div>
                <div class="hm-table__td">
                  <hm-input-number :label="$t('admin.interfaces.pageMeldeclient.nummernkreise.bis')"
                                   :inline="true"
                                   :id="`maximumInteger-${nummernkreisIdx}`"
                                   v-model="nummernkreis.maximumInteger"
                                   name="maximumInteger" />
                </div>
              </template>
            </template>
          </hm-table>

        </hm-card-inner>
      </card>
      <card :title="$t('admin.interfaces.pageMeldeclient.card.feratel')" cols="12 6@desktop">
        <hm-card-inner>
          <hm-input-toggle id="requireBirthDate"
                           :label="$t('admin.interfaces.pageMeldeclient.requireBirthDate')"
                           v-model="config.requireBirthDate"
                           :disabled="!hasRole('ROLE_SYSADMIN') || config.hasGuestCard"
                           cols="12 6@hd start-1"
                           name="requireBirthDate" />
          <hm-input-toggle id="travelDocumentRequiredForeigners"
                           :label="$t('admin.interfaces.pageMeldeclient.travelDocumentRequiredForeigners')"
                           v-model="config.travelDocumentRequiredForeigners"
                           cols="12 6@hd start-1"
                           name="travelDocumentRequiredForeigners" />
          <hm-input-toggle id="travelDocumentRequiredLocals"
                           :label="$t('admin.interfaces.pageMeldeclient.travelDocumentRequiredLocals')"
                           v-model="config.travelDocumentRequiredLocals"
                           cols="12 6@hd start-1"
                           name="travelDocumentRequiredLocals" />
          <hm-input-toggle id="travelDocumentRequiredAdditionalGuests"
                           :label="$t('admin.interfaces.pageMeldeclient.travelDocumentRequiredAdditionalGuests')"
                           v-model="config.travelDocumentRequiredAdditionalGuests"
                           cols="12 6@hd start-1"
                           name="travelDocumentRequiredAdditionalGuests" />
          <hm-input-toggle id="digitalSignature"
                           :label="$t('admin.interfaces.pageMeldeclient.digitalSignature')"
                           v-model="config.digitalSignature"
                           cols="12 6@hd start-1"
                           name="digitalSignature" />
          <hm-input-toggle id="exactAge"
                           :label="$t('admin.interfaces.pageMeldeclient.exactAge')"
                           v-model="config.exactAge"
                           cols="12 6@hd start-1"
                           name="exactAge" />
          <hm-input-mask v-if="!config.exactAge"
                         v-model="config.ageEffectiveDate"
                         :label="$t('admin.interfaces.pageMeldeclient.ageEffectiveDate')"
                         :help="$t('admin.interfaces.pageMeldeclient.ageEffectiveDate_help', {format: dayMonthFormat, example: $moment('23-12', 'DD-MM').format(dayMonthFormat)})"
                         :mask="dayMonthMask"
                         type="text"
                         cols="12 6@hd start-1"
                         name="ageEffectiveDate" />
          <hm-input-toggle id="allowStorno"
                           v-if="isPrint"
                           :label="$t('admin.interfaces.pageMeldeclient.allowStorno')"
                           v-model="config.allowStorno"
                           :disabled="!hasRole('ROLE_SYSADMIN')"
                           cols="12 6@hd start-1"
                           name="allowStorno" />
        </hm-card-inner>
        <template v-if="isInterface">
          <hm-card-inner :title="$t('admin.interfaces.pageMeldeclient.card.feratelGeneral')">
            <hm-input-toggle v-if="isFeratel || isAVS"
                             id="hasGuestCard"
                             :label="$t('admin.interfaces.pageMeldeclient.hasGuestCard')"
                             v-model="config.hasGuestCard"
                             :disabled="!hasRole('ROLE_SYSADMIN')"
                             cols="12 6@hd start-1"
                             name="hasGuestCard" />
            <hm-input-toggle v-if="isAVS && config.hasGuestCard"
                             id="avsUsePrimaryGuestEmail"
                             :label="$t('admin.interfaces.pageMeldeclient.avsUsePrimaryGuestEmail')"
                             v-model="config.avsUsePrimaryGuestEmail"
                             cols="12 6@hd start-1"
                             name="avsUsePrimaryGuestEmail" />
            <hm-input-toggle v-if="isFeratel"
                             id="supportsPreRegistration"
                             :label="$t('admin.interfaces.pageMeldeclient.supportsPreRegistration')"
                             v-model="config.supportsPreRegistration"
                             :disabled="!hasRole('ROLE_SYSADMIN')"
                             cols="12 6@hd start-1"
                             name="maxNumberGuestsGroup" />
            <hm-input-toggle id="allowStorno"
                             :label="$t('admin.interfaces.pageMeldeclient.allowStorno')"
                             v-model="config.allowStorno"
                             :disabled="!hasRole('ROLE_SYSADMIN')"
                             cols="12 6@hd start-1"
                             name="allowStorno" />
            <hm-input id="cityId"
                      :label="$t('admin.interfaces.pageMeldeclient.cityId')"
                      v-model="config.cityId"
                      cols="12 6@hd start-1"
                      name="cityId" />
            <hm-input id="hotelIdNumeric"
                      :label="$t('admin.interfaces.pageMeldeclient.hotelIdNumeric')"
                      v-model="config.hotelIdNumeric"
                      cols="12 6@hd start-1"
                      name="hotelIdNumeric" />
            <hm-input v-if="isFeratel"
                      id="hotelIdAlphanumeric"
                      :label="$t('admin.interfaces.pageMeldeclient.hotelIdAlphanumeric')"
                      v-model="config.hotelIdAlphanumeric"
                      cols="12 6@hd start-1"
                      name="hotelIdAlphanumeric" />
            <hm-input id="untervermieterId"
                      :label="$t('admin.interfaces.pageMeldeclient.untervermieterId')"
                      v-model="config.untervermieterId"
                      cols="12 6@hd start-1"
                      name="untervermieterId" />
            <template v-if="isRequireUsernamePassword ">
              <hm-input id="username"
                        :label="$t('admin.interfaces.pageMeldeclient.username')"
                        v-model="config.username"
                        cols="12 6@hd start-1"
                        name="username" />
              <hm-input id="password"
                        :label="$t('admin.interfaces.pageMeldeclient.password')"
                        v-model="config.password"
                        cols="12 6@hd start-1"
                        name="password" />
            </template>
          </hm-card-inner>
          <hm-card-inner v-if="['AVS'].includes(config.typ)" :title="$t('admin.interfaces.pageMeldeclient.card.avsGenderMapping')">
            <hm-input-select :label="$t('Gender.Male')" v-model="config.avsGenderAnredeMap['Male']">
              <option :value="null"></option>
              <option v-for="anrede in config.avsAnrede" :value="anrede.key" :key="anrede.key">{{ anrede.value }} ({{ anrede.key }})</option>
            </hm-input-select>
            <hm-input-select :label="$t('Gender.Female')" v-model="config.avsGenderAnredeMap['Female']">
              <option :value="null"></option>
              <option v-for="anrede in config.avsAnrede" :value="anrede.key" :key="anrede.key">{{ anrede.value }} ({{ anrede.key }})</option>
            </hm-input-select>
            <hm-input-select :label="$t('Gender.Undeclared')" v-model="config.avsGenderAnredeMap['Undeclared']">
              <option :value="null"></option>
              <option v-for="anrede in config.avsAnrede" :value="anrede.key" :key="anrede.key">{{ anrede.value }} ({{ anrede.key }})</option>
            </hm-input-select>
          </hm-card-inner>
          <hm-card-inner v-if="!['AVS', 'Print'].includes(config.typ)" :title="$t('admin.interfaces.pageMeldeclient.card.feratelTechnical')">
            <hm-input v-if="isLegacyFeratel"
                      id="interfaceLink"
                      :label="$t('admin.interfaces.pageMeldeclient.interfaceLink')"
                      :disabled="!hasRole('ROLE_SYSADMIN')"
                      v-model="config.interfaceLink"
                      cols="12 start-1"
                      name="interfaceLink" />
            <hm-input id="meldeblattPrintBlankLink"
                      :label="$t('admin.interfaces.pageMeldeclient.meldeblattPrintBlankLink')"
                      :disabled="!hasRole('ROLE_SYSADMIN')"
                      v-model="config.meldeblattPrintBlankLink"
                      cols="12 start-1"
                      name="interfaceLink" />
            <hm-input id="meldeblattPrintLink"
                      :label="$t('admin.interfaces.pageMeldeclient.meldeblattPrintLink')"
                      :disabled="!hasRole('ROLE_SYSADMIN')"
                      v-model="config.meldeblattPrintLink"
                      cols="12 start-1"
                      name="meldeblattPrintLink" />
            <hm-input id="meldeblattPreviewPrintLink"
                      :label="$t('admin.interfaces.pageMeldeclient.meldeblattPreviewPrintLink')"
                      :disabled="!hasRole('ROLE_SYSADMIN')"
                      v-model="config.meldeblattPreviewPrintLink"
                      cols="12 start-1"
                      name="meldeblattPreviewPrintLink" />
            <hm-input v-if="config.hasGuestCard"
                      id="guestCardLink"
                      :label="$t('admin.interfaces.pageMeldeclient.guestCardLink')"
                      :disabled="!hasRole('ROLE_SYSADMIN')"
                      v-model="config.guestCardLink"
                      cols="12 start-1"
                      name="guestCardLink" />
            <hm-input id="preCheckInBaseLink"
                      :label="$t('admin.interfaces.pageMeldeclient.preCheckInBaseLink')"
                      :disabled="!hasRole('ROLE_SYSADMIN')"
                      v-model="config.preCheckInBaseLink"
                      cols="12 start-1"
                      name="preCheckInBaseLink" />
            <hm-input id="selfCheckInBaseLink"
                      :label="$t('admin.interfaces.pageMeldeclient.selfCheckInBaseLink')"
                      :disabled="!hasRole('ROLE_SYSADMIN')"
                      v-model="config.selfCheckInBaseLink"
                      cols="12 start-1"
                      name="selfCheckInBaseLink" />
            <template v-if="isFeratel">
              <hm-input id="feratelMcNumber"
                        :label="$t('admin.interfaces.pageMeldeclient.feratelMcNumber')"
                        :disabled="!hasRole('ROLE_SYSADMIN')"
                        v-model="config.feratelMcNumber"
                        cols="12 start-1"
                        name="feratelMcNumber" />
              <hm-input id="feratelRegionCode"
                        :label="$t('admin.interfaces.pageMeldeclient.feratelRegionCode')"
                        :disabled="!hasRole('ROLE_SYSADMIN')"
                        v-model="config.feratelRegionCode"
                        cols="12 start-1"
                        name="feratelRegionCode" />
              <hm-input id="feratelWebclientDbCode"
                        :label="$t('admin.interfaces.pageMeldeclient.feratelWebclientDbCode')"
                        :disabled="!hasRole('ROLE_SYSADMIN')"
                        v-model="config.feratelWebclientDbCode"
                        cols="12 start-1"
                        name="feratelWebclientDbCode" />
            </template>
            <hm-button cols="12@mobile 6"
                       class="btn--red btn--no-margin"
                       icon-left="close"
                       @click="resetToDefaultLinks">{{ $t('admin.interfaces.pageMeldeclient.actions.resetToDefaultLinks') }}</hm-button>
          </hm-card-inner>
        </template>
      </card>
      <template v-if="['AVS'].includes(config.typ)">
        <card :title="$t('admin.interfaces.pageMeldeclient.avsAdditionalFields')" cols="12" min-height="600px">
          <dynamic-table-editor v-model="config.customFieldsGuest"
                                :auto-extend="true"
                                :empty-record="{
                                  fieldName: null,
                                  label: null,
                                  displayAlways: false,
                                  maxLength: 50,
                                  valueList: [],
                                  displayGastart: [],
                                  requiredGastart: [],
                                  type: 'String',
                                }"
                                :table-headings="['Tag-Name', 'Bezeichnung', 'Typ', 'Max. Länge', 'Werteliste', 'Immer sichtbar?', 'Sichtbar', 'Erforderlich']"
                                :not-valued="(it) => isEmpty(it.fieldName)"
                                :label="$t('admin.interfaces.pageMeldeclient.card.guestAdditionalFields')"
                                min-width="1024px">
            <template v-slot:default="props">
              <div class="hm-table__td">
                <hm-input :inline="true"
                          :id="`fieldName-${props.valueIdx}`"
                          v-model="props.value.fieldName"
                          :disabled="['sb-versorgungsamtnr', 'sb-gueltig-bis', 'firmenname', 'freie-tage', 'taetigkeitsort'].includes(props.value.fieldName) && !hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                          label="Tag-Name"
                          name="fieldName" />
              </div>
              <div class="hm-table__td">
                <hm-input :inline="true"
                          :id="`label-${props.valueIdx}`"
                          v-model="props.value.label"
                          :disabled="isEmpty(props.value.fieldName)"
                          :label="$t('admin.interfaces.pageMeldeclient.additionalFields.label')"
                          name="label" />
              </div>
              <div class="hm-table__td">
                <hm-input-select :inline="true"
                                 :id="`type-${props.valueIdx}`"
                                 v-model="props.value.type"
                                 :disabled="isEmpty(props.value.fieldName) || (['sb-versorgungsamtnr', 'sb-gueltig-bis', 'firmenname', 'freie-tage'].includes(props.value.fieldName) && !hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN'))"
                                 :label="$t('admin.interfaces.pageMeldeclient.additionalFields.type')"
                                 enum-name="MeldeblattCustomFieldType"
                                 name="type" />
              </div>
              <div class="hm-table__td">
                <hm-input v-if="props.value.type === 'String'"
                          :inline="true"
                          :id="`maxLength-${props.valueIdx}`"
                          v-model="props.value.maxLength"
                          :disabled="isEmpty(props.value.fieldName)"
                          :label="$t('admin.interfaces.pageMeldeclient.additionalFields.maxLength')"
                          name="maxLength" />
              </div>
              <div class="hm-table__td">

                <hm-input v-if="props.value.type === 'Dropdown'"
                          :inline="true"
                          :id="`valueList-${props.valueIdx}`"
                          :value="(props.value.valueList || []).join('|')"
                          :disabled="isEmpty(props.value.fieldName)"
                          :label="$t('admin.interfaces.pageMeldeclient.additionalFields.valueList')"
                          name="valueList"
                          @input="(value) => { props.value.valueList = isEmpty(value) ? [] : value.split('|'); }" />
              </div>
              <div class="hm-table__td">
                <hm-input-checkbox :inline="true"
                                   :id="`displayAlways-${props.valueIdx}`"
                                   v-model="props.value.displayAlways"
                                   :disabled="isEmpty(props.value.fieldName)"
                                   :label="$t('admin.interfaces.pageMeldeclient.additionalFields.visible')"
                                   name="displayAlways"
                                   @input="(value) => { if (value) { props.value.displayGastart = config.gastarten.map((it) => it.code); } }" />
              </div>
              <div :style="`z-index: ${10000 - props.valueIdx};`"
                   class="hm-table__td hm-table__td--overflow">
                <hm-multiselect v-if="!props.value.displayAlways"
                                :inline="true"
                                :id="`displayGastart-${props.valueIdx}`"
                                :options="config.gastarten"
                                :limit="1"
                                :disabled="isEmpty(props.value.fieldName)"
                                v-model="props.value.displayGastart"
                                :label="$t('admin.interfaces.pageMeldeclient.additionalFields.displayGastart')"
                                value-expression="code"
                                label-expression="${option.name.de}"
                                style="max-width:250px;"
                                name="displayGastart"
                                @input="(value) => { props.value.requiredGastart = props.value.requiredGastart.filter((it) => (value || []).includes(it))}" />
              </div>
              <div :style="`z-index: ${10000 - props.valueIdx};`"
                   class="hm-table__td hm-table__td--overflow">
                <hm-multiselect :inline="true"
                                :id="`requiredGastart-${props.valueIdx}`"
                                :key="(props.value.displayGastart || []).length"
                                :options="config.gastarten.filter(it => props.value.displayGastart.includes(it.code))"
                                :limit="1"
                                :disabled="isEmpty(props.value.fieldName)"
                                v-model="props.value.requiredGastart"
                                :label="$t('admin.interfaces.pageMeldeclient.additionalFields.requiredGastart')"
                                value-expression="code"
                                label-expression="${option.name.de}"
                                style="max-width:250px;"
                                name="requiredGastart" />
              </div>
            </template>
          </dynamic-table-editor>
        </card>
      </template>
    </template>
    <hm-floating-buttons>
      <hm-floating-button v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                          :label="$t('admin.interfaces.pageMeldeclient.actions.deleteInterface')"
                          icon="delete"
                          color="red"
                          @click="deleteInterface" />
      <hm-floating-button v-if="isFeratel && !isLegacyFeratel && hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                          :throttle="3500"
                          :label="$t('admin.interfaces.pageMeldeclient.actions.retrievePreCheckIns')"
                          icon="download"
                          color="gray"
                          @click="retrievePreCheckIns()" />
      <hm-floating-button v-if="isFeratel && !isLegacyFeratel"
                          :throttle="3500"
                          :label="$t('admin.interfaces.pageMeldeclient.actions.updateMeldeblattNumbers')"
                          icon="fill-numbers"
                          color="orange"
                          @click="updateMeldeblattNumbers()" />
      <hm-floating-button v-if="canUpdateConfig"
                          :throttle="3500"
                          :label="$t('admin.interfaces.pageMeldeclient.actions.updateConfig')"
                          icon="download"
                          color="orange"
                          @click="showConfirmModal('Möglicherweise werden hierdurch manuell getätigte Einstellungen überschrieben.', updateConfig)" />
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import vue2Dropzone from 'vue2-dropzone';
import draggable from 'vuedraggable';
import { cloneDeep, groupBy, isEmpty, isNil, sortBy, last, lastIndexOf, first, indexOf } from 'lodash';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import Card from '../../../lib/layout/Card';
import HmInputCheckbox from '../../../lib/inputs/HmInputCheckbox';
import HmInputMoney from '../../../lib/inputs/HmInputMoney';
import HmCardInner from '../../../lib/layout/HmCardInner';
import HmTextarea from '../../../lib/inputs/HmTextarea';
import HmTable from '../../../lib/table/HmTable';
import HmCol from '../../../lib/layout/HmCol.vue';
import HmInputSelect from '../../../lib/inputs/HmInputSelect.vue';
import DynamicTableEditor from '../../../lib/inputgroups/DynamicTableEditor.vue';
import HmMultiselect from '../../../lib/inputs/HmMultiselect.vue';
import HmInputToggle from '../../../lib/inputs/HmInputToggle.vue';

export default {
  name: 'PageMeldeclient',
  components: { HmInputToggle, HmMultiselect, DynamicTableEditor, HmInputSelect, HmCol, HmTable, HmTextarea, HmCardInner, HmInputMoney, HmInputCheckbox, Card },
  mixins: [HotelmeisterMixin, SaveWatchMixin],

  autosave: [
    {
      name: 'config',
      variable: 'config',
      fn: function (cbSaveComplete) {
        const toSave = cloneDeep(this.config);

        if (isEmpty(toSave.ageEffectiveDate)) {
          toSave.ageEffectiveDate = null;
        }

        if (!isEmpty(toSave.ageEffectiveDate)) {
          toSave.ageEffectiveDate = this.$moment(toSave.ageEffectiveDate, this.dayMonthFormat).format('DD-MM').split(/[^0-9]+/g);
        }

        toSave.gastarten = toSave.gastarten.filter(it => !isEmpty(it.code));
        toSave.nummernkreise = toSave.nummernkreise
          .filter(it => !isNil(it.minimumInteger) && !isNil(it.maximumInteger))
          .filter(it => it.minimumInteger >= 0 && it.maximumInteger > 0)
          .filter(it => it.maximumInteger >= it.minimumInteger);

        this.axios.put(this.serviceUrls.interfaces.meldeclient.get(this, this.interfaceId), toSave)
          .then((response) => {
            this.showMessages(response);
            cbSaveComplete();
          })
          .catch((error) => {
            if (isNil(error.response)) this.showErrorMessage();
            this.showMessages(error.response);
            cbSaveComplete();
          });
      },
    },
  ],

  data() {
    return {
      config: null,
      savedConfig: null,
      interfaceId: this.$route.params.interfaceId,
      nummernkreiseLocked: true,
    };
  },

  computed: {
    isPrint() {
      if (isNil(this.config)) return false;
      switch (this.config.typ) {
        case 'Print': return true;
        default: return false;
      }
    },
    isFeratel() {
      if (isNil(this.config)) return false;
      switch (this.config.typ) {
        case 'Print': return false;
        case 'CUeGBv1': return false;
        case 'AVS': return false;
        default: return true;
      }
    },
    isAVS() {
      if (isNil(this.config)) return false;
      return ['AVS'].includes(this.config.typ);
    },
    isInterface() {
      if (isNil(this.config)) return false;
      switch (this.config.typ) {
        case 'Print': return false;
        default: return true;
      }
    },
    isLegacyFeratel() {
      if (!this.isFeratel) return false;
      switch (this.config.typ) {
        case 'FeratelV2':
        case 'FeratelV5':
          return true;
        default:
          return false;
      }
    },
    isRequireUsernamePassword() {
      switch (this.config.typ) {
        case 'FeratelV2':
        case 'FeratelV5':
        case 'CUeGBv1':
          return true;
        default:
          return false;
      }
    },
    enums: function () {
      return this.$store.getters['enums/enums'];
    },
    canUpdateConfig() {
      if (this.isFeratel && !this.isLegacyFeratel) return true;
      if (this.isAVS) return true;
      else return false;
    },
  },

  watch: {
    'config.typ': function (newVal, oldVal) {
      if (!isNil(oldVal)) {
        if (['Print', 'CUeGBv1'].includes(this.config.typ)) {
          this.config.gastarten.push({
            code: null,
            name: {
              de: null,
            },
            ageFrom: 0,
            ageUntil: 0,
            primaryGuestOnly: false,
          });
        } else if (['AVS'].includes(this.config.typ)) {
          this.config.maxNumberGuests = 99;
          this.config.maxNumberGuestsGroup = 1;
        } else {
          this.config.maxNumberGuests = 6;
          this.config.maxNumberGuestsGroup = 99;
          this.config.gastarten = this.config.gastarten.filter(it => !isEmpty(it.code));
        }
      }
    },
    'config.gastarten': {
      handler: function () {
        if (['Print', 'CUeGBv1'].includes(this.config.typ)) {
          if (this.config.gastarten.filter(it => isEmpty(it.code)).length === 0) {
            this.config.gastarten.push({
              code: null,
              name: {
                de: null,
              },
              ageFrom: 0,
              ageUntil: 0,
              primaryGuestOnly: false,
            });
          } else if (this.config.gastarten.filter(it => isEmpty(it.code)).length > 1) {
            const toDelete = first(this.config.gastarten.filter(it => isEmpty(it.code)));
            this.config.gastarten.splice(indexOf(this.config.gastarten, toDelete), 1);
          }
        }
      },
      deep: true,
    },
    'config.nummernkreise': {
      handler: function () {
        if (['Print', 'CUeGBv1'].includes(this.config.typ)) {
          if (this.config.nummernkreise.filter(it => isNil(it.minimumInteger) || isNil(it.maximumInteger)).length === 0) {
            this.config.nummernkreise.push({
              minimumInteger: null,
              maximumInteger: null,
            });
          }
        }
      },
      deep: true,
    },
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    isGastartEmpty(it) {
      return isEmpty(it.code);
    },
    isEmpty,
    preProcessConfig(config) {
      const tmp = cloneDeep(config);
      if (!isNil(tmp.ageEffectiveDate)) {
        tmp.ageEffectiveDate = this.$moment(`${tmp.ageEffectiveDate[0]}-${tmp.ageEffectiveDate[1]}`, 'DD-MM').format(this.dayMonthFormat);
      }
      if (isNil(tmp.customFieldsMeldeblatt)) tmp.customFieldsMeldeblatt = [];
      if (isNil(tmp.customFieldsGuest)) tmp.customFieldsGuest = [];
      return tmp;
    },
    loadData() {
      this.axios.get(this.serviceUrls.interfaces.meldeclient.get(this, this.interfaceId))
        .then((response) => {
          if (isNil(this.config)) {
            this.config = this.preProcessConfig(response.data.data);
            this.savedConfig = cloneDeep(this.config);
          }
        });
    },
    updateConfig() {
      this.axios.post(this.serviceUrls.interfaces.meldeclient.updateConfig(this, this.interfaceId))
        .then((response) => {
          this.config = this.preProcessConfig(response.data.data);
          this.showSuccessMessage();
        })
        .catch(() => {
          this.showErrorMessage();
        });
    },
    updateMeldeblattNumbers() {
      this.axios.post(this.serviceUrls.interfaces.meldeclient.updateMeldeblattNumbers(this, this.interfaceId))
        .then((response) => {
          this.config = this.preProcessConfig(response.data.data);
          this.showSuccessMessage();
        })
        .catch((error) => {
          this.showMessages(error.response);
        });
    },
    retrievePreCheckIns() {
      this.axios.post(this.serviceUrls.interfaces.meldeclient.retrievePreCheckIns(this, this.interfaceId))
        .then((response) => {
          this.config = this.preProcessConfig(response.data.data);
          this.showSuccessMessage();
        })
        .catch((error) => {
          this.showMessages(error.response);
        });
    },
    resetToDefaultLinks: function () {
      if (this.isFeratel) {
        if (this.config.typ === 'CUeGBv1') {
          this.config.guestCardLink = null;
          this.config.interfaceLink = null;
          this.config.meldeblattPrintLink = null;
          this.config.meldeblattPreviewPrintLink = null;
          this.config.meldeblattPrintBlankLink = null;
        } else if (this.isLegacyFeratel) {
          // eslint-disable-next-line no-template-curly-in-string
          this.config.interfaceLink = 'https://meldeclient.feratel.at/meldeclient/MCLInterfaceServlet/XMLIn?mcnummer=${config.feratelMcNumber}&username=${config.username}&password=${config.password}';
          // eslint-disable-next-line no-template-curly-in-string
          this.config.meldeblattPrintLink = 'https://meldeclient.feratel.at/meldeclient/MCLInterfaceServlet/print?mcnummer=${config.feratelMcNumber}&username=${config.username}&password=${config.password}&mblattnr=${meldeblatt.meldeblattNummer}';
          // eslint-disable-next-line no-template-curly-in-string
          this.config.meldeblattPreviewPrintLink = 'https://webclient4.deskline.net/${config.feratelMcNumber}/de/visitorregistrations/printpartialform?spCode=${config.hotelIdNumeric}&communityNumber=${config.cityId}&sheetId=${feratelGuid}';
          this.config.meldeblattPrintBlankLink = null;
        } else if (isEmpty(this.config.hotelIdAlphanumeric)) {
          // eslint-disable-next-line no-template-curly-in-string
          this.config.guestCardLink = 'https://visitortax.deskline.net/Services.asmx/PrintGuestCard?betriebnr=${config.hotelIdNumeric}&oestat=${config.cityId}&companyCode=${companyCode}&sheetNumber=${meldeblatt.meldeblattNummer}&printMainGuestOnly=false';
          this.config.interfaceLink = null;
          this.config.meldeblattPrintBlankLink = null;
          // eslint-disable-next-line no-template-curly-in-string
          this.config.meldeblattPrintLink = 'https://visitortax.deskline.net/Services.asmx/PrintVTForm?betriebnr=${config.hotelIdNumeric}&oestat=${config.cityId}&companyCode=${companyCode}&sheetNumber=${meldeblatt.meldeblattNummer}';
          // eslint-disable-next-line no-template-curly-in-string
          this.config.meldeblattPreviewPrintLink = 'https://webclient4.deskline.net/${config.feratelRegionCode}/de/visitorregistrations/printpartialform?dbOv=${config.feratelWebclientDbCode}&spCode=${config.hotelIdNumeric}&sheetId=${feratelGuid}&communityNumber=${config.cityId}';
        } else {
          // eslint-disable-next-line no-template-curly-in-string
          this.config.guestCardLink = 'https://visitortax.deskline.net/Services.asmx/PrintGuestCard?betriebnr=${config.hotelIdAlphanumeric}&oestat=${config.cityId}&companyCode=${companyCode}&sheetNumber=${meldeblatt.meldeblattNummer}&printMainGuestOnly=false';
          this.config.interfaceLink = null;
          this.config.meldeblattPrintBlankLink = null;
          // eslint-disable-next-line no-template-curly-in-string
          this.config.meldeblattPrintLink = 'https://visitortax.deskline.net/Services.asmx/PrintVTForm?betriebnr=${config.hotelIdAlphanumeric}&oestat=${config.cityId}&companyCode=${companyCode}&sheetNumber=${meldeblatt.meldeblattNummer}';
          // eslint-disable-next-line no-template-curly-in-string
          this.config.meldeblattPreviewPrintLink = 'https://webclient4.deskline.net/${config.feratelRegionCode}/de/visitorregistrations/printpartialform?dbOv=${config.feratelWebclientDbCode}&spCode=${config.hotelIdAlphanumeric}&sheetId=${feratelGuid}&communityNumber=${config.cityId}';
        }
      } else {
        this.config.guestCardLink = null;
        this.config.interfaceLink = null;
        this.config.meldeblattPrintBlankLink = null;
        this.config.meldeblattPrintLink = null;
        this.config.meldeblattPreviewPrintLink = null;
      }
    },
    deleteInterface(force = false) {
      if (force === true) {
        this.axios.delete(this.serviceUrls.interfaces.meldeclient.get(this, this.interfaceId))
          .then((response) => {
            this.showSuccessMessage();
            this.$serviceBus.$emit('interface.list');
            this.$router.push({ name: 'interfaces' });
          });
      } else {
        this.showConfirmModal(
          this.$t('admin.interfaces.pageMeldeclient.confirmDelete'),
          (doNotShowAgain) => {
            this.deleteInterface(true);
          },
        );
      }
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/interfaces/PageMeldeclient.vue